import { useQuery } from "@tanstack/react-query"
import { useCallback } from "react"
import { PacOption } from "@/components/TopNavigation/components/MultiPacSelector/types"
import { AVAILIABLE_PACS_QUERY_KEY } from "@/components/TopNavigation/components/MultiPacSelector/consts"

const { QuorumUser } = DjangIO.app.userdata.models

export const fetchAvailablePacs: () => Promise<[PacOption[], string]> = async () => {
    const { allowed_pacs, current_pacc_pac_id } = await QuorumUser.objects.get().action("get_available_pacs").GET()
    return [allowed_pacs, current_pacc_pac_id]
}

export const fetchAllAvailablePacs: () => Promise<PacOption[]> = async () => {
    const { allowed_pacs } = await QuorumUser.objects.get().action("get_all_available_pacs").GET()
    return allowed_pacs
}

export const fetchAllAssignablePacs: () => Promise<PacOption[]> = async () => {
    const { allowed_pacs } = await QuorumUser.objects.get().action("get_all_assignable_pacs").GET()
    return allowed_pacs
}

const selectAvailablePacs = (data: [PacOption[], string]) => ({ options: data[0], selectedPac: data[1] })

export const useAvailablePacs = () =>
    useQuery({
        queryKey: [AVAILIABLE_PACS_QUERY_KEY],
        queryFn: fetchAvailablePacs,
        select: useCallback((data) => selectAvailablePacs(data), []),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    })

export const useAllAvailablePacs = () =>
    useQuery({
        queryKey: ["allAvailablePacs"],
        queryFn: fetchAllAvailablePacs,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    })

export const useAllAssignablePacs = () =>
    useQuery({
        queryKey: ["allAssignablePacs"],
        queryFn: fetchAllAssignablePacs,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    })

export const saveNewSelectedPac = async (pacID: string) => {
    return await QuorumUser.objects.use_action("set_pacc_pac").update({ pac_id: pacID }).PATCH()
}

// Form-specific PAC option type with numeric ID for Redux-Form compatibility
export interface PacOptionForForms {
    id: number
    acronym: string
}

/**
 * Transform function to convert string IDs to numbers for form compatibility
 * This is the only transformation needed between the existing service and our forms
 */
export const transformPacOptionsForForms = (pacs: PacOption[]): PacOptionForForms[] => {
    return pacs.map((pac) => ({
        id: parseInt(pac.id, 10),
        acronym: pac.acronym,
    }))
}
